import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import { PromotedEventSportSection } from './PromotedEventSections';
import { PromotedEventCompetitionSectionWrapper } from './PromotedEventCompetitionSectionWrapper';
import { List as MovableList } from 'react-movable';
import { ListContentWrapper } from 'src/domains/layouts/shared/cms/list/List.style';
import { Response200Type } from 'src/api_openapi/generated/openapi_website_cms_getAllPromotedSports';
import { PromotedCompetitionsListState } from 'src/main/cms/PromotedEvents/promotedEventsList/promotedEventsSections/PromotedEventSportSectionWrapper.state';

export type PromotedSportDataModelType = Response200Type[number];

interface PropsType {
    sportData: PromotedSportDataModelType;
    isDragged: boolean;
}

export const PromotedEventSportSectionWrapper = observer(
    'PromotedEventSportSectionWrapper',
    ({ sportData, isDragged }: PropsType) => {
        const {
            cmsState: { promotedEventsState },
            sdkStaff,
            trpcClient,
        } = useAppStateContext();
        const promotedEventSportState = promotedEventsState.getPromotedEventSportStateBySportSlug(sportData.sport_id);
        const sortedCompetitionsData = sportData.competitions_list;
        const [promotedCompetitionsListState] = useState(
            () => new PromotedCompetitionsListState(sdkStaff, trpcClient, promotedEventsState, sportData)
        );

        const { sportName, handleCompetitionOrder } = promotedCompetitionsListState;

        if (promotedCompetitionsListState.isAnyCompetitions === false) {
            return null;
        }

        return (
            <>
                <PromotedEventSportSection
                    key={sportData.id}
                    label={sportName}
                    isOpen={promotedEventSportState.isOpenSection}
                    isDragged={isDragged}
                    promotedEventSportState={promotedEventSportState}
                    dataTest={`promoted-event-sport-${sportName.toLowerCase().replaceAll(' ', '')}`}
                />
                {promotedEventSportState.isOpenSection === false ? null : (
                    <MovableList
                        values={sortedCompetitionsData}
                        onChange={handleCompetitionOrder}
                        renderList={({ children, props, isDragged }): React.ReactNode => (
                            <ListContentWrapper
                                {...props}
                                isDragged={isDragged}
                            >
                                {children}
                            </ListContentWrapper>
                        )}
                        renderItem={({ value, props, isDragged }): JSX.Element | null => {
                            return (
                                <div
                                    {...props}
                                    style={{ ...props.style, zIndex: 'initial' }}
                                >
                                    <PromotedEventCompetitionSectionWrapper
                                        key={value.id}
                                        sportId={sportData.sport_id}
                                        competitionData={value}
                                        isDragged={isDragged}
                                        promotedEventSportState={promotedEventSportState}
                                    />
                                </div>
                            );
                        }}
                    />
                )}
            </>
        );
    }
);
